//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { LocalDate } from "@js-joda/core";import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export interface IAccountClient {
    signIn(cancelToken?: CancelToken): Promise<FileResponse | null>;
    signOut(cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class AccountClient implements IAccountClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    signIn( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Account/SignIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignIn(_response);
        });
    }

    protected processSignIn(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }

    signOut( cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/Account/SignOut";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignOut(_response);
        });
    }

    protected processSignOut(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface IApiKeyClient {
    getApiKeys(cancelToken?: CancelToken): Promise<ApiKeyDto[]>;
    createApiKey(createDto: CreateApiKeyDto, cancelToken?: CancelToken): Promise<ApiKeyDto>;
    revokeApiKey(id: number, cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ApiKeyClient implements IApiKeyClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getApiKeys( cancelToken?: CancelToken): Promise<ApiKeyDto[]> {
        let url_ = this.baseUrl + "/api/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetApiKeys(_response);
        });
    }

    protected processGetApiKeys(response: AxiosResponse): Promise<ApiKeyDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ApiKeyDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ApiKeyDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiKeyDto[]>(null as any);
    }

    createApiKey(createDto: CreateApiKeyDto, cancelToken?: CancelToken): Promise<ApiKeyDto> {
        let url_ = this.baseUrl + "/api/ApiKey";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(createDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateApiKey(_response);
        });
    }

    protected processCreateApiKey(response: AxiosResponse): Promise<ApiKeyDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ApiKeyDto.fromJS(resultData200);
            return Promise.resolve<ApiKeyDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ApiKeyDto>(null as any);
    }

    revokeApiKey(id: number, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/ApiKey/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRevokeApiKey(_response);
        });
    }

    protected processRevokeApiKey(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ICalendarClient {
    getRange(range: DateRangeDto, cancelToken?: CancelToken): Promise<CalendarDayDto[]>;
    getPublicHolidays(year: number, cancelToken?: CancelToken): Promise<PublicHolidayDto[]>;
    createPublicHoliday(publicHolidayDto: PublicHolidayDto, cancelToken?: CancelToken): Promise<PublicHolidayDto>;
    deletePublicHoliday(publicHolidayDto: PublicHolidayDto, cancelToken?: CancelToken): Promise<PublicHolidayDto>;
    resetPublicHolidays(year: number, cancelToken?: CancelToken): Promise<void>;
}

export class CalendarClient implements ICalendarClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRange(range: DateRangeDto, cancelToken?: CancelToken): Promise<CalendarDayDto[]> {
        let url_ = this.baseUrl + "/api/Calendar/GetRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRange(_response);
        });
    }

    protected processGetRange(response: AxiosResponse): Promise<CalendarDayDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalendarDayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<CalendarDayDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CalendarDayDto[]>(null as any);
    }

    getPublicHolidays(year: number, cancelToken?: CancelToken): Promise<PublicHolidayDto[]> {
        let url_ = this.baseUrl + "/api/Calendar/{year}";
        if (year === undefined || year === null)
            throw new Error("The parameter 'year' must be defined.");
        url_ = url_.replace("{year}", encodeURIComponent("" + year));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetPublicHolidays(_response);
        });
    }

    protected processGetPublicHolidays(response: AxiosResponse): Promise<PublicHolidayDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(PublicHolidayDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<PublicHolidayDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayDto[]>(null as any);
    }

    createPublicHoliday(publicHolidayDto: PublicHolidayDto, cancelToken?: CancelToken): Promise<PublicHolidayDto> {
        let url_ = this.baseUrl + "/api/Calendar/CreatePublicHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publicHolidayDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreatePublicHoliday(_response);
        });
    }

    protected processCreatePublicHoliday(response: AxiosResponse): Promise<PublicHolidayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayDto.fromJS(resultData200);
            return Promise.resolve<PublicHolidayDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayDto>(null as any);
    }

    deletePublicHoliday(publicHolidayDto: PublicHolidayDto, cancelToken?: CancelToken): Promise<PublicHolidayDto> {
        let url_ = this.baseUrl + "/api/Calendar/DeletePublicHoliday";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(publicHolidayDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeletePublicHoliday(_response);
        });
    }

    protected processDeletePublicHoliday(response: AxiosResponse): Promise<PublicHolidayDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PublicHolidayDto.fromJS(resultData200);
            return Promise.resolve<PublicHolidayDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PublicHolidayDto>(null as any);
    }

    resetPublicHolidays(year: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Calendar/ResetPublicHolidays";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(year);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processResetPublicHolidays(_response);
        });
    }

    protected processResetPublicHolidays(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IEntriesClient {
    getRangeForCurrentUser(range: DateRangeDto, cancelToken?: CancelToken): Promise<EntryDto[]>;
    updateForCurrentUser(updates: EntryDto[], cancelToken?: CancelToken): Promise<void>;
    deleteForCurrentUer(entryIdsToDelete: number[], cancelToken?: CancelToken): Promise<void>;
}

export class EntriesClient implements IEntriesClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getRangeForCurrentUser(range: DateRangeDto, cancelToken?: CancelToken): Promise<EntryDto[]> {
        let url_ = this.baseUrl + "/api/Entries/getRange";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRangeForCurrentUser(_response);
        });
    }

    protected processGetRangeForCurrentUser(response: AxiosResponse): Promise<EntryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(EntryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<EntryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EntryDto[]>(null as any);
    }

    updateForCurrentUser(updates: EntryDto[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Entries/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updates);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateForCurrentUser(_response);
        });
    }

    protected processUpdateForCurrentUser(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteForCurrentUer(entryIdsToDelete: number[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Entries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(entryIdsToDelete);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteForCurrentUer(_response);
        });
    }

    protected processDeleteForCurrentUer(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IProjectClient {
    getAssignedToCurrentUser(cancelToken?: CancelToken): Promise<ProjectDto[]>;
    getAssignedToUser(userId: number, cancelToken?: CancelToken): Promise<ProjectDto[]>;
    setUserAssignedTasks(userId: number, tasks: number[], cancelToken?: CancelToken): Promise<void>;
    getAll(cancelToken?: CancelToken): Promise<ProjectDto[]>;
    createProject(project: ProjectDto, cancelToken?: CancelToken): Promise<number>;
    renameProject(projectId: number, name: string, cancelToken?: CancelToken): Promise<void>;
    deleteProject(projectId: number, cancelToken?: CancelToken): Promise<void>;
    createTask(projectId: number, taskDto: ProjectTaskDto, cancelToken?: CancelToken): Promise<number>;
    deleteTask(taskId: number, cancelToken?: CancelToken): Promise<void>;
    renameTask(taskId: number, name: string, cancelToken?: CancelToken): Promise<void>;
}

export class ProjectClient implements IProjectClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getAssignedToCurrentUser( cancelToken?: CancelToken): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/Project/assigned/me";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignedToCurrentUser(_response);
        });
    }

    protected processGetAssignedToCurrentUser(response: AxiosResponse): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    getAssignedToUser(userId: number, cancelToken?: CancelToken): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/Project/assigned/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAssignedToUser(_response);
        });
    }

    protected processGetAssignedToUser(response: AxiosResponse): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    setUserAssignedTasks(userId: number, tasks: number[], cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/assigned/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(tasks);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSetUserAssignedTasks(_response);
        });
    }

    protected processSetUserAssignedTasks(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getAll( cancelToken?: CancelToken): Promise<ProjectDto[]> {
        let url_ = this.baseUrl + "/api/Project/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAll(_response);
        });
    }

    protected processGetAll(response: AxiosResponse): Promise<ProjectDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<ProjectDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ProjectDto[]>(null as any);
    }

    createProject(project: ProjectDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/Project";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(project);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateProject(_response);
        });
    }

    protected processCreateProject(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    renameProject(projectId: number, name: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/RenameProject";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameProject(_response);
        });
    }

    protected processRenameProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    deleteProject(projectId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteProject(_response);
        });
    }

    protected processDeleteProject(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    createTask(projectId: number, taskDto: ProjectTaskDto, cancelToken?: CancelToken): Promise<number> {
        let url_ = this.baseUrl + "/api/Project/{projectId}/tasks";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(taskDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCreateTask(_response);
        });
    }

    protected processCreateTask(response: AxiosResponse): Promise<number> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<number>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number>(null as any);
    }

    deleteTask(taskId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/tasks/{taskId}";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTask(_response);
        });
    }

    protected processDeleteTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    renameTask(taskId: number, name: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Project/tasks/{taskId}/rename";
        if (taskId === undefined || taskId === null)
            throw new Error("The parameter 'taskId' must be defined.");
        url_ = url_.replace("{taskId}", encodeURIComponent("" + taskId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(name);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRenameTask(_response);
        });
    }

    protected processRenameTask(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IReportsClient {
    getTimeAllocationReport(range: DateRangeDto, cancelToken?: CancelToken): Promise<TimeAllocationReportDto[]>;
    exportExcel(request: ExcelExportRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null>;
}

export class ReportsClient implements IReportsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getTimeAllocationReport(range: DateRangeDto, cancelToken?: CancelToken): Promise<TimeAllocationReportDto[]> {
        let url_ = this.baseUrl + "/api/Reports/getTimeAllocationReport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(range);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetTimeAllocationReport(_response);
        });
    }

    protected processGetTimeAllocationReport(response: AxiosResponse): Promise<TimeAllocationReportDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TimeAllocationReportDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<TimeAllocationReportDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<TimeAllocationReportDto[]>(null as any);
    }

    exportExcel(request: ExcelExportRequestDto, cancelToken?: CancelToken): Promise<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Reports/exportExcel";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportExcel(_response);
        });
    }

    protected processExportExcel(response: AxiosResponse): Promise<FileResponse | null> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data], { type: response.headers["content-type"] as string | undefined }), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse | null>(null as any);
    }
}

export interface ISettingsClient {
    getWorktimeSettings(cancelToken?: CancelToken): Promise<WorktimeSettingsDto>;
    updateWorktimeSettings(worktimeSettingsDto: WorktimeSettingsDto, cancelToken?: CancelToken): Promise<void>;
}

export class SettingsClient implements ISettingsClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    getWorktimeSettings( cancelToken?: CancelToken): Promise<WorktimeSettingsDto> {
        let url_ = this.baseUrl + "/api/Settings/worktime";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetWorktimeSettings(_response);
        });
    }

    protected processGetWorktimeSettings(response: AxiosResponse): Promise<WorktimeSettingsDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = WorktimeSettingsDto.fromJS(resultData200);
            return Promise.resolve<WorktimeSettingsDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<WorktimeSettingsDto>(null as any);
    }

    updateWorktimeSettings(worktimeSettingsDto: WorktimeSettingsDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Settings/worktime";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(worktimeSettingsDto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWorktimeSettings(_response);
        });
    }

    protected processUpdateWorktimeSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export interface IUserClient {
    loggedIn(cancelToken?: CancelToken): Promise<boolean>;
    userInfo(cancelToken?: CancelToken): Promise<UserDto>;
    balances(cancelToken?: CancelToken): Promise<BalancesDto>;
}

export class UserClient implements IUserClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    loggedIn( cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/User/LoggedIn";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processLoggedIn(_response);
        });
    }

    protected processLoggedIn(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;

            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    userInfo( cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/User/UserInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUserInfo(_response);
        });
    }

    protected processUserInfo(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    balances( cancelToken?: CancelToken): Promise<BalancesDto> {
        let url_ = this.baseUrl + "/api/User/Balances";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processBalances(_response);
        });
    }

    protected processBalances(response: AxiosResponse): Promise<BalancesDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = BalancesDto.fromJS(resultData200);
            return Promise.resolve<BalancesDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<BalancesDto>(null as any);
    }
}

export interface IUsersClient {
    list(cancelToken?: CancelToken): Promise<UserDto[]>;
    getById(userId: number, cancelToken?: CancelToken): Promise<UserDto>;
    updateWorktimeSettings(userId: number, body: UserWorktimeSettingsDto, cancelToken?: CancelToken): Promise<void>;
    getSupervisors(userId: number, cancelToken?: CancelToken): Promise<number[]>;
    addSupervisor(userId: number, supervisorId: number, cancelToken?: CancelToken): Promise<void>;
    removeSupervisor(userId: number, supervisorId: number, cancelToken?: CancelToken): Promise<void>;
    getFlexAdjustments(userId: number, cancelToken?: CancelToken): Promise<FlexAdjustmentDto[]>;
    addFlexAdjustment(userId: number, dto: CreateFlexAdjustmentDto, cancelToken?: CancelToken): Promise<void>;
    getFlexHistory(userId: number, cancelToken?: CancelToken): Promise<FlexHistoryDto[]>;
    getHolidayAdjustments(userId: number, cancelToken?: CancelToken): Promise<HolidayAdjustmentDto[]>;
    addHolidayAdjustment(userId: number, dto: CreateHolidayAdjustmentDto, cancelToken?: CancelToken): Promise<void>;
}

export class UsersClient implements IUsersClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "";

    }

    list( cancelToken?: CancelToken): Promise<UserDto[]> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UserDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<UserDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto[]>(null as any);
    }

    getById(userId: number, cancelToken?: CancelToken): Promise<UserDto> {
        let url_ = this.baseUrl + "/api/Users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetById(_response);
        });
    }

    protected processGetById(response: AxiosResponse): Promise<UserDto> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UserDto.fromJS(resultData200);
            return Promise.resolve<UserDto>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UserDto>(null as any);
    }

    updateWorktimeSettings(userId: number, body: UserWorktimeSettingsDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/settings/worktime";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdateWorktimeSettings(_response);
        });
    }

    protected processUpdateWorktimeSettings(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getSupervisors(userId: number, cancelToken?: CancelToken): Promise<number[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/supervisors";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetSupervisors(_response);
        });
    }

    protected processGetSupervisors(response: AxiosResponse): Promise<number[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<number[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<number[]>(null as any);
    }

    addSupervisor(userId: number, supervisorId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/supervisors/{supervisorId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (supervisorId === undefined || supervisorId === null)
            throw new Error("The parameter 'supervisorId' must be defined.");
        url_ = url_.replace("{supervisorId}", encodeURIComponent("" + supervisorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddSupervisor(_response);
        });
    }

    protected processAddSupervisor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    removeSupervisor(userId: number, supervisorId: number, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/supervisors/{supervisorId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (supervisorId === undefined || supervisorId === null)
            throw new Error("The parameter 'supervisorId' must be defined.");
        url_ = url_.replace("{supervisorId}", encodeURIComponent("" + supervisorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "DELETE",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processRemoveSupervisor(_response);
        });
    }

    protected processRemoveSupervisor(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFlexAdjustments(userId: number, cancelToken?: CancelToken): Promise<FlexAdjustmentDto[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/flexAdjustments";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlexAdjustments(_response);
        });
    }

    protected processGetFlexAdjustments(response: AxiosResponse): Promise<FlexAdjustmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlexAdjustmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FlexAdjustmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlexAdjustmentDto[]>(null as any);
    }

    addFlexAdjustment(userId: number, dto: CreateFlexAdjustmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/flexAdjustments";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddFlexAdjustment(_response);
        });
    }

    protected processAddFlexAdjustment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }

    getFlexHistory(userId: number, cancelToken?: CancelToken): Promise<FlexHistoryDto[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/flexHistory";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetFlexHistory(_response);
        });
    }

    protected processGetFlexHistory(response: AxiosResponse): Promise<FlexHistoryDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FlexHistoryDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<FlexHistoryDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FlexHistoryDto[]>(null as any);
    }

    getHolidayAdjustments(userId: number, cancelToken?: CancelToken): Promise<HolidayAdjustmentDto[]> {
        let url_ = this.baseUrl + "/api/Users/{userId}/holidayAdjustments";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetHolidayAdjustments(_response);
        });
    }

    protected processGetHolidayAdjustments(response: AxiosResponse): Promise<HolidayAdjustmentDto[]> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(HolidayAdjustmentDto.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return Promise.resolve<HolidayAdjustmentDto[]>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<HolidayAdjustmentDto[]>(null as any);
    }

    addHolidayAdjustment(userId: number, dto: CreateHolidayAdjustmentDto, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/Users/{userId}/holidayAdjustments";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(dto);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddHolidayAdjustment(_response);
        });
    }

    protected processAddHolidayAdjustment(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ApiKeyDto implements IApiKeyDto {
    id!: number;
    key!: string;
    userId!: number;
    userName!: string;
    createdAt!: LocalDate;

    constructor(data?: IApiKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.key = _data["key"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.createdAt = _data["createdAt"] ? LocalDate.parse(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ApiKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new ApiKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["key"] = this.key;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["createdAt"] = this.createdAt ? formatLocalDate(this.createdAt) : <any>undefined;
        return data;
    }
}

export interface IApiKeyDto {
    id: number;
    key: string;
    userId: number;
    userName: string;
    createdAt: LocalDate;
}

export class CreateApiKeyDto implements ICreateApiKeyDto {
    userId!: number;

    constructor(data?: ICreateApiKeyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
        }
    }

    static fromJS(data: any): CreateApiKeyDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateApiKeyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        return data;
    }
}

export interface ICreateApiKeyDto {
    userId: number;
}

export class CalendarDayDto implements ICalendarDayDto {
    date!: LocalDate;
    target!: number;

    constructor(data?: ICalendarDayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? LocalDate.parse(_data["date"].toString()) : <any>undefined;
            this.target = _data["target"];
        }
    }

    static fromJS(data: any): CalendarDayDto {
        data = typeof data === 'object' ? data : {};
        let result = new CalendarDayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatLocalDate(this.date) : <any>undefined;
        data["target"] = this.target;
        return data;
    }
}

export interface ICalendarDayDto {
    date: LocalDate;
    target: number;
}

export class DateRangeDto implements IDateRangeDto {
    start!: LocalDate;
    end!: LocalDate;

    constructor(data?: IDateRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.start = _data["start"] ? LocalDate.parse(_data["start"].toString()) : <any>undefined;
            this.end = _data["end"] ? LocalDate.parse(_data["end"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): DateRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new DateRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["start"] = this.start ? formatLocalDate(this.start) : <any>undefined;
        data["end"] = this.end ? formatLocalDate(this.end) : <any>undefined;
        return data;
    }
}

export interface IDateRangeDto {
    start: LocalDate;
    end: LocalDate;
}

export class PublicHolidayDto implements IPublicHolidayDto {
    date!: LocalDate;
    name!: string;

    constructor(data?: IPublicHolidayDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.date = _data["date"] ? LocalDate.parse(_data["date"].toString()) : <any>undefined;
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): PublicHolidayDto {
        data = typeof data === 'object' ? data : {};
        let result = new PublicHolidayDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? formatLocalDate(this.date) : <any>undefined;
        data["name"] = this.name;
        return data;
    }
}

export interface IPublicHolidayDto {
    date: LocalDate;
    name: string;
}

export class EntryDto implements IEntryDto {
    id!: number;
    date!: LocalDate;
    taskId!: number;
    time!: number;
    description!: string;

    constructor(data?: IEntryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.date = _data["date"] ? LocalDate.parse(_data["date"].toString()) : <any>undefined;
            this.taskId = _data["taskId"];
            this.time = _data["time"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): EntryDto {
        data = typeof data === 'object' ? data : {};
        let result = new EntryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["date"] = this.date ? formatLocalDate(this.date) : <any>undefined;
        data["taskId"] = this.taskId;
        data["time"] = this.time;
        data["description"] = this.description;
        return data;
    }
}

export interface IEntryDto {
    id: number;
    date: LocalDate;
    taskId: number;
    time: number;
    description: string;
}

export class ProjectDto implements IProjectDto {
    id!: number;
    name!: string;
    tasks!: ProjectTaskDto[];

    constructor(data?: IProjectDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.tasks = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            if (Array.isArray(_data["tasks"])) {
                this.tasks = [] as any;
                for (let item of _data["tasks"])
                    this.tasks!.push(ProjectTaskDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        if (Array.isArray(this.tasks)) {
            data["tasks"] = [];
            for (let item of this.tasks)
                data["tasks"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectDto {
    id: number;
    name: string;
    tasks: ProjectTaskDto[];
}

export class ProjectTaskDto implements IProjectTaskDto {
    id!: number;
    name!: string;

    constructor(data?: IProjectTaskDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): ProjectTaskDto {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTaskDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IProjectTaskDto {
    id: number;
    name: string;
}

export class TimeAllocationReportDto implements ITimeAllocationReportDto {
    description!: string;
    time!: number;
    date!: LocalDate;
    taskName!: string;
    projectId!: number;
    projectName!: string;
    taskId!: number;
    userId!: number;
    userName!: string;
    rowId!: number;

    constructor(data?: ITimeAllocationReportDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.description = _data["description"];
            this.time = _data["time"];
            this.date = _data["date"] ? LocalDate.parse(_data["date"].toString()) : <any>undefined;
            this.taskName = _data["taskName"];
            this.projectId = _data["projectId"];
            this.projectName = _data["projectName"];
            this.taskId = _data["taskId"];
            this.userId = _data["userId"];
            this.userName = _data["userName"];
            this.rowId = _data["rowId"];
        }
    }

    static fromJS(data: any): TimeAllocationReportDto {
        data = typeof data === 'object' ? data : {};
        let result = new TimeAllocationReportDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["description"] = this.description;
        data["time"] = this.time;
        data["date"] = this.date ? formatLocalDate(this.date) : <any>undefined;
        data["taskName"] = this.taskName;
        data["projectId"] = this.projectId;
        data["projectName"] = this.projectName;
        data["taskId"] = this.taskId;
        data["userId"] = this.userId;
        data["userName"] = this.userName;
        data["rowId"] = this.rowId;
        return data;
    }
}

export interface ITimeAllocationReportDto {
    description: string;
    time: number;
    date: LocalDate;
    taskName: string;
    projectId: number;
    projectName: string;
    taskId: number;
    userId: number;
    userName: string;
    rowId: number;
}

export class ExcelExportRequestDto implements IExcelExportRequestDto {
    range!: DateRangeDto;
    userId?: number | undefined;
    projectId?: number | undefined;

    constructor(data?: IExcelExportRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.range = _data["range"] ? DateRangeDto.fromJS(_data["range"]) : <any>undefined;
            this.userId = _data["userId"];
            this.projectId = _data["projectId"];
        }
    }

    static fromJS(data: any): ExcelExportRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new ExcelExportRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["range"] = this.range ? this.range.toJSON() : <any>undefined;
        data["userId"] = this.userId;
        data["projectId"] = this.projectId;
        return data;
    }
}

export interface IExcelExportRequestDto {
    range: DateRangeDto;
    userId?: number | undefined;
    projectId?: number | undefined;
}

export class WorktimeSettingsDto implements IWorktimeSettingsDto {
    entriesLockedUntil!: LocalDate;
    minAllowedAccuracy!: number;

    constructor(data?: IWorktimeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.entriesLockedUntil = _data["entriesLockedUntil"] ? LocalDate.parse(_data["entriesLockedUntil"].toString()) : <any>undefined;
            this.minAllowedAccuracy = _data["minAllowedAccuracy"];
        }
    }

    static fromJS(data: any): WorktimeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new WorktimeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["entriesLockedUntil"] = this.entriesLockedUntil ? formatLocalDate(this.entriesLockedUntil) : <any>undefined;
        data["minAllowedAccuracy"] = this.minAllowedAccuracy;
        return data;
    }
}

export interface IWorktimeSettingsDto {
    entriesLockedUntil: LocalDate;
    minAllowedAccuracy: number;
}

export class UserDto implements IUserDto {
    userId!: number;
    name!: string;
    email!: string;
    admin!: boolean;
    flex?: number | undefined;
    worktimeSettings!: UserWorktimeSettingsDto;
    organization!: OrganizationDto;
    assignedProjects!: ProjectDto[];

    constructor(data?: IUserDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.worktimeSettings = new UserWorktimeSettingsDto();
            this.organization = new OrganizationDto();
            this.assignedProjects = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.admin = _data["admin"];
            this.flex = _data["flex"];
            this.worktimeSettings = _data["worktimeSettings"] ? UserWorktimeSettingsDto.fromJS(_data["worktimeSettings"]) : new UserWorktimeSettingsDto();
            this.organization = _data["organization"] ? OrganizationDto.fromJS(_data["organization"]) : new OrganizationDto();
            if (Array.isArray(_data["assignedProjects"])) {
                this.assignedProjects = [] as any;
                for (let item of _data["assignedProjects"])
                    this.assignedProjects!.push(ProjectDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["name"] = this.name;
        data["email"] = this.email;
        data["admin"] = this.admin;
        data["flex"] = this.flex;
        data["worktimeSettings"] = this.worktimeSettings ? this.worktimeSettings.toJSON() : <any>undefined;
        data["organization"] = this.organization ? this.organization.toJSON() : <any>undefined;
        if (Array.isArray(this.assignedProjects)) {
            data["assignedProjects"] = [];
            for (let item of this.assignedProjects)
                data["assignedProjects"].push(item.toJSON());
        }
        return data;
    }
}

export interface IUserDto {
    userId: number;
    name: string;
    email: string;
    admin: boolean;
    flex?: number | undefined;
    worktimeSettings: UserWorktimeSettingsDto;
    organization: OrganizationDto;
    assignedProjects: ProjectDto[];
}

export class UserWorktimeSettingsDto implements IUserWorktimeSettingsDto {
    flexCalculationDisabled!: boolean;
    calculationStartDate!: LocalDate;
    partTimeMultiplier!: number;

    constructor(data?: IUserWorktimeSettingsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flexCalculationDisabled = _data["flexCalculationDisabled"];
            this.calculationStartDate = _data["calculationStartDate"] ? LocalDate.parse(_data["calculationStartDate"].toString()) : <any>undefined;
            this.partTimeMultiplier = _data["partTimeMultiplier"];
        }
    }

    static fromJS(data: any): UserWorktimeSettingsDto {
        data = typeof data === 'object' ? data : {};
        let result = new UserWorktimeSettingsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flexCalculationDisabled"] = this.flexCalculationDisabled;
        data["calculationStartDate"] = this.calculationStartDate ? formatLocalDate(this.calculationStartDate) : <any>undefined;
        data["partTimeMultiplier"] = this.partTimeMultiplier;
        return data;
    }
}

export interface IUserWorktimeSettingsDto {
    flexCalculationDisabled: boolean;
    calculationStartDate: LocalDate;
    partTimeMultiplier: number;
}

export class OrganizationDto implements IOrganizationDto {
    name!: string;
    id!: string;
    entryLockDate!: LocalDate;

    constructor(data?: IOrganizationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
            this.entryLockDate = _data["entryLockDate"] ? LocalDate.parse(_data["entryLockDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): OrganizationDto {
        data = typeof data === 'object' ? data : {};
        let result = new OrganizationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        data["entryLockDate"] = this.entryLockDate ? formatLocalDate(this.entryLockDate) : <any>undefined;
        return data;
    }
}

export interface IOrganizationDto {
    name: string;
    id: string;
    entryLockDate: LocalDate;
}

export class BalancesDto implements IBalancesDto {
    flex!: number;
    holiday!: number;

    constructor(data?: IBalancesDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.flex = _data["flex"];
            this.holiday = _data["holiday"];
        }
    }

    static fromJS(data: any): BalancesDto {
        data = typeof data === 'object' ? data : {};
        let result = new BalancesDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["flex"] = this.flex;
        data["holiday"] = this.holiday;
        return data;
    }
}

export interface IBalancesDto {
    flex: number;
    holiday: number;
}

export class FlexAdjustmentDto implements IFlexAdjustmentDto {
    id!: number;
    amount!: number;
    description!: string;
    createdBy!: string;
    createdAt!: LocalDate;

    constructor(data?: IFlexAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? LocalDate.parse(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): FlexAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlexAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? formatLocalDate(this.createdAt) : <any>undefined;
        return data;
    }
}

export interface IFlexAdjustmentDto {
    id: number;
    amount: number;
    description: string;
    createdBy: string;
    createdAt: LocalDate;
}

export class CreateFlexAdjustmentDto implements ICreateFlexAdjustmentDto {
    amount!: number;
    description!: string;

    constructor(data?: ICreateFlexAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateFlexAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateFlexAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateFlexAdjustmentDto {
    amount: number;
    description: string;
}

export class FlexHistoryDto implements IFlexHistoryDto {
    userId!: number;
    date!: LocalDate;
    dailyChange!: number;
    totalFlex!: number;

    constructor(data?: IFlexHistoryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"];
            this.date = _data["date"] ? LocalDate.parse(_data["date"].toString()) : <any>undefined;
            this.dailyChange = _data["dailyChange"];
            this.totalFlex = _data["totalFlex"];
        }
    }

    static fromJS(data: any): FlexHistoryDto {
        data = typeof data === 'object' ? data : {};
        let result = new FlexHistoryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["date"] = this.date ? formatLocalDate(this.date) : <any>undefined;
        data["dailyChange"] = this.dailyChange;
        data["totalFlex"] = this.totalFlex;
        return data;
    }
}

export interface IFlexHistoryDto {
    userId: number;
    date: LocalDate;
    dailyChange: number;
    totalFlex: number;
}

export class HolidayAdjustmentDto implements IHolidayAdjustmentDto {
    id!: number;
    amount!: number;
    description!: string;
    createdBy!: string;
    createdAt!: LocalDate;

    constructor(data?: IHolidayAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.amount = _data["amount"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.createdAt = _data["createdAt"] ? LocalDate.parse(_data["createdAt"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): HolidayAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new HolidayAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["amount"] = this.amount;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["createdAt"] = this.createdAt ? formatLocalDate(this.createdAt) : <any>undefined;
        return data;
    }
}

export interface IHolidayAdjustmentDto {
    id: number;
    amount: number;
    description: string;
    createdBy: string;
    createdAt: LocalDate;
}

export class CreateHolidayAdjustmentDto implements ICreateHolidayAdjustmentDto {
    amount!: number;
    description!: string;

    constructor(data?: ICreateHolidayAdjustmentDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amount = _data["amount"];
            this.description = _data["description"];
        }
    }

    static fromJS(data: any): CreateHolidayAdjustmentDto {
        data = typeof data === 'object' ? data : {};
        let result = new CreateHolidayAdjustmentDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amount"] = this.amount;
        data["description"] = this.description;
        return data;
    }
}

export interface ICreateHolidayAdjustmentDto {
    amount: number;
    description: string;
}

function formatDate(d: Date) {
    return d.getFullYear() + '-' +
        (d.getMonth() < 9 ? ('0' + (d.getMonth()+1)) : (d.getMonth()+1)) + '-' +
        (d.getDate() < 10 ? ('0' + d.getDate()) : d.getDate());
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

function formatLocalDate(d: LocalDate) {
    return d.toString();
}
